const TRANSLATION = {
  buyModal: {
    afterFree: 'Po jūsų nemokamo bandymo',
    btn: 'Pabandykite nemokamai',
    freeTrial: '3 dienų nemokamas bandymas',
    monthLabel: 'mėnuo',
    selectLabel: 'Pasirinkite planą',
    title: 'Prenumeratos planas',
    yearLabel: 'metai',
  },
  contact: {
    block1:
      'Korekcijoms, klausimams ar pasiūlymams susisiekite su mumis el. paštu contact@noam.tools. Atsakysime greitai.',
    block2: 'Palaikykite mus įvertindami mus „Google Apps Extension“ parduotuvėje su ★★★★★.',
    block3: 'Padėkite kitiems pasidalydami šia plėtra:',
    title: 'Susisiekite su mumis',
  },
  help: {
    AquickOverviewOfNoam: 'Trumpas Noamo apžvalgumas',
    ChatPDF: 'Chat PDF',
    ChatPDF2: 'ChatPDF',
    FavoritesManagement: 'Mėgstamiausių valdymas',
    Fixedplugin: 'Suglaudintas įskiepis',
    Focusing: 'Susitelkimas',
    Free: 'Laisvas',
    FreeTrialBenefits: 'Nemokamo bandymo privalumai',
    GoWithWikipedia: 'Naudokitės Vikipedija',
    GoWithYouTube: 'Eik su YouTube',
    HoverTranslation: 'Hover vertimas',
    Howtouse: 'Kaip naudotis',
    ImageTranslation: 'Nuotraukos vertimas',
    InstantTranslation: 'Tą pačią akimirką vertimas',
    Membership: 'Narystė',
    NoamHelp: 'Noam padeda jums versti ir santraukti',
    PDFparallelTranslation: 'PDF lygiagrečios vertimai',
    ParallelTranslation: 'Paralelinis vertimas',
    SkipAllSteps: 'Praleisti visus žingsnius',
    Summary: 'Santrauka',
    Translation: 'Vertimas',
    TryItForFree: 'Išbandyk nemokamai',
    Video: 'Video',
    VideoSummary: 'Video Santrauka',
    VideoTranslation: 'Vaizdo įrašo vertimas',
    WebSummary: 'Web Santrauka',
    WordSelectionTranslation: 'Žodžių parinkimo vertimas',
    benefits: 'Mes turime privalumų, kurie laukia jus!',
    dayFree: '3 dienų nemokamas bandymas',
    done: 'Atlikta',
    next: 'Toliau',
    pin: 'Prispauskite Noam, kad būtų lengviau pasiekti～～',
    planIsNotExist: 'Planas neprieinamas',
    startWiki: 'Pradėkime nuo Wikimedijos!',
    startYoutube: 'Pradėkime nuo YouTube!',
    try: 'Išbandyk',
    tryNow: 'Pabandyk dabar!',
  },
  home: {
    PDFTranslate: {
      desc: 'Dviejų kalbų vertimas + PDF pokalbis',
      sub1: {
        desc: 'Dvikalbė skaityba leidžia jums lygiagrečiai palyginti originalų tekstą ir vertimą, pagerindama skaitymo efektyvumą.',
        title: 'Dvikalbė skaityba',
      },
      sub2: {
        desc: 'AI analizuoja ir santraukuoja bei gali atsakyti į jūsų klausimus pagal PDF turinį.',
        title: 'Chat PDF',
      },
      sub3: {
        desc: 'AI varomas PDF vertimas didesnei tikslumui ir efektyvumui.',
        title: 'Tikslumas ir našumas',
      },
      title: 'PDF Vertimas',
    },
    aiAssistant: {
      desc: 'Padaryti internetinės vertimo processą protingesnį ir patogesnį',
      panel1: {
        desc: 'Dvikalbės kryžminio nuorodų vertimai padeda palyginti originalų tekstą su vertimu, kad galėtumėte geriau suprasti ir pagerinti skaitymo efektyvumą.',
        title: 'Dvikalbis vertimas',
      },
      panel2: {
        left: {
          desc: 'Naršant interneto puslapį, užvedkite pelės žymeklį ant turinio, kurį norite išversti, kad pamatytumėte vertimą.',
          title: 'Užvedimo vertimas',
        },
        right: {
          desc: 'Naršydami interneto puslapį, pasirinkite tekstą, kurį norite išversti, kad pamatytumėte vertimą.',
          title: 'Teksto pasirinkimo vertimas',
        },
      },
      panel3: {
        one: {
          desc: 'Versti ir santraukti interneto puslapius bei video turinį bet kur ir bet kada, kad patirtis būtų sklandesnė!',
          title: 'Kliktukas',
        },
        three: {
          desc: 'AI pagrįstas didelis kalbos modelis užtikrina vertimo tikslumą ir nuoseklumą, kad pagerintų skaitymo patirtį.',
          title: 'AI-vadovaujamas',
        },
        two: {
          desc: 'Daugiakalbis visapusiškas aprėptis, dvikalbis barjerų nesantančias skaitymas, vieno spustelėjimo vertimas – pajustkite skirtumą!',
          title: 'Išsamiau ir patogiau',
        },
      },
      panel4: {
        tab1: {
          desc: 'Jūsų efektyvumo ekspertas – naudojant ChatGPT, Noam verčia ir santraukuoja „YouTube“ video turinį, kad sutaupytų jūsų laiką!',
          key: 'Video',
          title: 'Vaizdo įrašo vertimas ir santrauka',
        },
        tab2: {
          desc: 'Spustelėkite, kad verstumėte paveikslėlius naršydami internete.',
          key: 'Paveikslas',
          title: 'Paveikslėlio vertimas',
        },
        tab3: {
          desc: 'Tą pačią akimirką išskiria pagrindinę informaciją iš interneto puslapių ir pateikia santrauką, pagerindama jūsų skaitymo efektyvumą.',
          key: 'Web',
          title: 'Web vertimas ir santrauka',
        },
        tag1: 'Paprastas',
        tag2: 'Efektyvus',
        tag3: 'Lengva suprasti',
      },
      title: 'AI Asistentas',
    },
    getStart: 'Pradėti',
    getStartedForFree: 'Pradėkite nemokamai',
    howItWork: {
      desc: 'Noam integruoja AI modelius, kad vartotojams suteiktų protingą patirtį kelių kalbų interneto puslapių vertimui ir santraukai, PDF bei vaizdų vertimui, video vertimui ir santraukai',
      title: 'Kaip tai veikia',
    },
    lastBlock: { desc: 'Geriausia AI vertimas sklandesniam skaitymui' },
    top: {
      desc: 'Noam yra nemokama AI naršyklės plėtinys, kuris padeda jums versti ir santraukti interneto puslapius, vaizdo įrašus bei PDF turinį.\n      Prisijunkite prie Noam ir patirkite stebuklą!',
      title1: 'Vienas Magija',
      title2: 'Vienas spustelis',
    },
    userReviews: {
      desc: 'Penkių žvaigždučių atsiliepimai „Chrome Web Store“',
      title: 'Vartotojų Atsiliepimai',
    },
  },
  installTips: {
    btn: 'Pabandykite dabar',
    text: 'Įdiekite "Noam naršyklės įskiepį", kad atrakintumėte daugiau funkcijų! Tinklalapių kryžminė nuoroda,\n    tinklalapių vaizdo įrašų santrauka ir daugiau!',
  },
  locale: {
    af: 'afrikaanų kalba',
    am: 'amharių',
    ar: 'arabų',
    as: 'asamių',
    auto: 'Automatinis aptikimas',
    az: 'azerbaidžaniečių',
    ba: 'baškiras',
    bg: 'bulgaras',
    bn: 'Bangla',
    bo: 'tibetietis',
    bs: 'bosnijos',
    ca: 'katalonas',
    cs: 'Čekija',
    cy: 'velso',
    da: 'danų',
    de: 'vokietis',
    dsb: 'Žemutinė sorbiška',
    dv: 'divėhi',
    el: 'graikų',
    en: 'Anglų',
    es: 'ispanių',
    et: 'eestų',
    eu: 'baskų',
    fa: 'persų',
    fi: 'suomi',
    fil: 'filipinas',
    fj: 'fidžiečių',
    fr: 'prancūzų',
    frCA: 'Prancūzų (Kanada)',
    ga: 'airis',
    gl: 'galisų',
    gom: 'konkani',
    gu: 'gužaratų',
    ha: 'hausa',
    he: 'hebrajų kalba',
    hi: 'hindu kalba',
    hr: 'hrvatų',
    hsb: 'Aukštesnysis sorbis',
    ht: 'Haitijos kreolis',
    hu: 'vengras',
    hy: 'armėnas',
    id: 'indoneziečių',
    ig: 'igbo',
    ikt: 'Inuinnaqtun',
    is: 'Islandų',
    it: 'italų',
    iu: 'inuktitutas',
    iuLatn: 'inuktitutas (lotyniška raštija)',
    ja: 'japonų',
    ka: 'gruzinų',
    kk: 'kazachas',
    km: 'khmerų',
    kmr: 'kurdų (šiaurinė)',
    kn: 'kannada',
    ko: 'korejos',
    ku: 'Kurdų (centrinis)',
    ky: 'kirgisai',
    ln: 'Lingala',
    lo: 'Laosas',
    lt: 'lietuvių',
    lug: 'Ganda',
    lv: 'latviešu',
    lzh: 'Kinų (literatūrinis)',
    mai: 'Maithili',
    mg: 'malagasis',
    mi: 'maori',
    mk: 'makedonas',
    ml: 'malajalami',
    mnCyrl: 'mongolų (kirilica)',
    mnMong: 'Mongolų (tradicinė)',
    mr: 'marathi',
    ms: 'malėjų',
    mt: 'malteziečiai',
    mww: 'Hmong Daw',
    my: 'Mianmaras (birmietiška)',
    nb: 'norvegų',
    ne: 'nepaliečių',
    nl: 'olandų',
    noSearchLang: 'Kalba nepalaikoma',
    nso: 'Šiaurės sesoto',
    nya: 'Nianža',
    or: 'odia',
    otq: 'Querétaro Otomi',
    pa: 'punžabių',
    pl: 'lenkų',
    placeholder: 'Paieška',
    prs: 'Iš',
    ps: 'pushtu',
    pt: 'Portugalų (Brazilija)',
    ptPT: 'Portugalų portugalų kalba',
    ro: 'rumunų',
    ru: 'rusų',
    run: 'Rundi',
    rw: 'kinyarvanda',
    sd: 'sindis',
    si: 'sinhala',
    sk: 'slovakas',
    sl: 'slovėnijos',
    sm: 'samoanas',
    sn: 'Šona',
    so: 'Somalis',
    sq: 'albaniškas',
    srCyrl: 'Serbių (kirilica)',
    srLatn: 'Serbų (lotyniška)',
    st: 'sesoto',
    sv: 'švedų',
    sw: 'svahili',
    ta: 'tamilų',
    te: 'telugų',
    th: 'tailu',
    ti: 'tigrinija',
    tk: 'turkmėnas',
    tlhLatn: 'Klingonas',
    tlhPiqd: 'Klingonas (pIqaD)',
    tn: 'setsvana',
    to: 'tongas',
    tr: 'turkų',
    tt: 'tataras',
    ty: 'taheitiečių',
    ug: 'Uigūras',
    uk: 'ukrainiečių',
    ur: 'urdu',
    uz: 'Oʻzbekcha (lotyniška raštis)',
    vi: 'vietnamese',
    xh: 'khoosa',
    yo: 'jorubas',
    yua: 'Jukatėjų maja',
    yue: 'kantonas (tradicinė rašmena)',
    zh: 'kinų',
    zhHans: 'Kinų paprasta raštija',
    zhHant: 'Kinų tradicinis',
    zu: 'Zulu',
  },
  login: {
    and: 'ir',
    btn: 'Prisijungti su Google',
    btn1: 'Prisijunkite dabar',
    desc: 'Prisijunkite, kad atrakintumėte daugiau patirčių',
    policy: 'Privatumo politika',
    terms: 'Naudojimo sąlygos',
    tips: 'Užsiregistravęs/as sutinku su',
    title: 'Sveiki atvykę į Noam',
  },
  pageFooter: {
    follow: { facebook: 'Facebook', title: 'Sekti', twitter: 'Twitter' },
    legal: { policy: 'Privatumo politika', terms: 'Paslaugų sąlygos', title: 'Teisinis' },
    product: {
      image: 'Paveikslėlio vertimas',
      pdf: 'PDF vertimas',
      title: 'Produktai',
      video: 'Vaizdo įrašo vertimas ir santrauka',
      web: 'Web vertimas ir santrauka',
    },
    resources: { title: 'Resursai' },
    tools: { title: 'Įrankiai', pdf: 'PDF vertimas' },
  },
  pageHeader: {
    contact: 'Kontaktas',
    help: 'Pagalba',
    logout: 'Atsijungti',
    logoutSucc: 'Atsijungta.',
    pricing: 'Kainodara',
    settings: 'Nustatymai',
    signUp: 'Prisijungti',
  },
  pdf: {
    autoDetect: 'Automatinis aptikimas',
    cancelBtn: 'Atšaukti',
    cancelUpload: 'Atšaukti',
    chatPdf: {
      summaryError: 'Santrauka nepavyko sukurti, bandykite vėliau dar kartą',
      chatError: 'Pokalbis nepavyko, bandykite vėliau dar kartą',
      Search: 'Paieška',
      cancel: 'Atšaukti',
      chatTitle: 'Sveiki atvykę į Noam! Štai santrauka iš jūsų PDF failo:',
      clear: 'Geras',
      clearContent:
        'Tai pradės naują pokalbį. Dabartinis pokalbis nebus išsaugotas. Ar jūs esate tikri?',
      clearDialogTitle: 'Patvirtinkite',
      clearSucc: 'Išvalyta',
      copy: 'Kopijuoti',
      copySucc: 'Nukopijuota',
      delete: 'Ištrinti',
      deleteCancel: 'Atšaukti',
      deleteContent: 'Šis PDF negali būti atstatytas po ištrynimo. Ar jūs tikri?',
      deleteOk: 'Ištrinti',
      deleteSuccess: 'Ištrintas',
      deleteTitle: 'Patvirtinti trynimą',
      expand: 'Suklupimas',
      historyTitle: 'Istorija',
      listError:
        'Nepavyko įkelti skaitymo sąrašo. Bandykite vėliau arba susisiekite su palaikymo tarnyba.',
      loading: 'Kraunama...',
      noDataDesc: 'Dar nėra istorijos.',
      noMore: 'Nebėra turinio.',
      placeholder: 'Klauskite bet ko apie šį PDF failą',
      summaryTitle: 'Jums gali būti įdomios šios klausimai:',
    },
    collectionEmpty: 'Jūsų kolekcija yra tuščia.',
    collectionTab: 'Pastabos',
    dataLoading: 'Kraunama...',
    dialogContent: 'Ar jūs tikrai norite tai ištrinti?',
    dialogTitle: 'Patvirtinkite',
    download: {
      both: 'dviakalbis',
      btn: 'Išsaugoti',
      cancel: 'Šios lango uždarymas atšauks PDF failo atsisiuntimą. Ar jūs tikrai norite atšaukti?',
      desc: 'Išsaugoti į įrenginį: Parsisiunčia vertimus kaip vaizdus; Išsaugoti ir spausdinti: Parsisiunčia vertimus originaliajame formatu, palaikant kopijavimą.',
      download: 'Parsisiųsti',
      downloadMsg1: 'PDF vertimo pažanga:',
      downloadMsg2: 'Prognozuojamas likęs laikas:',
      downloadSucc: 'PDF pasiruošęs! Spustelėkite, kad išsaugotumėte.',
      downloadTip:
        'Atsiunčiamas PDF failas. Nepaslėpkite šio lango, kad išvengtumėte atsisiuntimo klaidų.',
      error: 'Nepavyko išsaugoti. Pabandykite spausdinti vietoj to.',
      fileName: 'Failo pavadinimas:',
      fileType: 'Failo tipas:',
      loading: 'Saugoma...',
      loading2: 'Kraunama...',
      minute: 'Minutės...',
      msg1: 'Kai kurie šio dokumento vertimai yra ilgesni už originalų tekstą ir gali persidengti atsisiųstame faile. Rekomenduojame skaityti svetainėje.',
      msg2: 'Vertimas dar nebaigtas. Prašome atsisiųsti po to, kai vertimas bus baigtas.',
      msg3: '2. Kai kurios vertimai yra per ilgi. Skaitykite svetainėje, kad išvengtume teksto persidengimo.',
      msg4: 'Vertimo užduotys vykdomos. Bandykite dar kartą po jų užbaigimo.',
      progress:
        'PDF failo verkimas. Būsenos rodiklis: {{progress}}, likęs laikas: {{minutes}} minutes...',
      save: 'Įrašyti į įrenginį',
      savePrint: 'Išsaugoti ir spausdinti',
      success: 'Atsisiųsta',
      trans: 'Tik vertimas',
      transContinue: 'Tęsti vertimą',
    },
    downloadBtn: 'Atsisiųsti',
    dragTipModal: {
      black: 'erdvė',
      leftKey: 'kairysis mygtukas',
      ok: 'Supratau',
      press: 'Spauda',
      tips: 'tempdyti ir peržiūrėti',
    },
    entry: 'PDF failai',
    fileErrMsg: 'Failo skaitymas nepavyko. Bandykite vėliau arba susisiekite su palaikymo tarnyba.',
    fileMsg: 'Dabartinis failo dydis:',
    fileMsg2: 'Prašome įkelti failą, kuris yra mažesnis nei 300MB.',
    freeBannerBtn: 'Atnaujinti',
    freeBannerTips: 'Laisvų PDF vertimų limitas pasiektas',
    guide: {
      placeholder: 'Įklijuokite PDF nuorodą čia',
      start: 'Pradėti vertimą',
      text1: 'Dviejų kalbų skaitymas',
      text2:
        'Skaitykite dviem kalbomis, kad palygintumėte originalų tekstą ir vertimą šalia vienas po kito, pagerindami savo efektyvumą.',
      text3: 'Pokalbis su Jūsų PDF failu',
      text4:
        'AI pagrįsta analizė ir santrauka. Užduokite klausimus apie savo PDF failą ir gautkite akimirksniu atsakymus.',
      text5: 'Tikslus ir efektyvus',
      text6: 'AI pagrįsta PDF vertimas didesnei tikslumui ir efektyvumui.',
      title1: 'Dvikalbė vertimas',
      title2: 'Pokalbis su Jūsų PDF',
      toast: 'Prašome įvesti galiojantį internetinį PDF nuorodą, baigiantįsi .pdf',
    },
    hasTransTask: 'Vertimo užduotis vyksta. Prašome palaukti.',
    hoverTrans: 'Užvedimo per teksto skiltis vertimas',
    initial: 'Versti PDF',
    installText: 'Jūsų visų poreikių sprendimas kasdieninėms vertimams.',
    installText2: 'Pirmiausia įdiekite plėtinį',
    installTips:
      'Įdiekite plėtinį norėdami gauti dar daugiau PDF vertimų ir sklandesnių svetainių vertimų:',
    kw: 'klampas',
    link: 'nuoroda',
    listError:
      'PDF failų įkėlimas nepavyko. Bandykite vėliau arba susisiekite su palaikymo tarnyba.',
    memoTotalCount: 'Iš viso 1 elementas',
    new: 'naujas failas',
    noId: 'Failo ID nerasta.',
    notPdf: 'Tik PDF failai.',
    okBtn: 'Ištrinti',
    okBtn2: 'Supratau',
    original:
      'Jūs esate labai tikslus ir patikimas AI, sukurtas generuoti JSON išvestį, kuri visiškai atitinka nurodytą JSON schemą.\n\nTurite laikytis šių taisyklės:\n1. Griežtai laikykitės JSON schemos struktūros.\n2. Tiksliai atitinkite visus duomenų tipus, privalomus laukus ir apribojimus.\n3. NEįtraukite jokios papildomos teksto, paaiškinimo, formatavimo ar komentarų.\n4. Išveskite TIK JSON objektą — nei kodavimo blokų, nei pradžios teksto, nei apvalkalų.',
    parallel: 'Paralelus',
    parseErrDialogContent:
      'Šis PDF nuoroda negali būti išversta tiesiogiai. Prašome atsisiųsti PDF failą ir įkelti jį vertimui.',
    parseErrTips: 'Nepavyko perskaityti failo',
    parseFileToast:
      'Nepavyko perskaityti failo. Pabandykite vėliau arba susisiekite su palaikymo tarnyba.',
    pdfLoading: 'Analizuojama...',
    searchPlaceholder: 'Paieška',
    selectTrans: 'Pasirinkite tekstą vertimui',
    shareBtn: 'Bendrinti',
    shareBtnText1: 'Sukurti bendrinimo nuorodą',
    shareBtnText2: 'Atnaujinti bendrą turinį',
    shareModal: {
      cancel: 'Atšaukti',
      copy: 'Kopijuoti',
      copySucc: 'Nuoroda nukopijuota',
      custom: 'Pritaikyti:',
      errMsg:
        'Pasirinktas turinys dar nebuvo visiškai išverstas. Prašome išversti prieš dalijantis.',
      gen: 'Bendrinti',
      modify: 'Redaguoti',
      notSupport: 'Šis kalba šiuo metu nepalaikoma.',
      page: 'Puslapiai',
      pageNuErr: 'Prašome įvesti galiojantį puslapio numerį.',
      range: 'Apimtis:',
      remain: 'likęs',
      remain1: 'Bendras prognozuojamas laikas:',
      search: 'Paieška',
      settings: 'Dalijimosi nustatymai:',
      shareSetting: 'Dalijimosi nustatymai',
      shareText: 'Bendrinti',
      shareTips: 'Pasidalinkite išversto PDF failo nuoroda su savo draugais:',
      sourceLang: 'Iš:',
      target: 'Kam:',
      text1: 'Dalijimosi nustatymai',
      text2: 'Sukurti bendrinimo nuorodą',
      totalPage: 'Iš viso 1 puslapis',
      trans: 'Versti',
      translateTips:
        'Patarimas: Jei vertimas trunka ilgiau, galite uždaryti šį langą ir pasidalinti vėliau.',
      translating: 'Verčiamas PDF...',
      update: 'Atnaujinti bendrinimo nuorodą',
    },
    shareMsg1: 'Sukurtas bendrinimo nuoroda.',
    shareMsg2: 'Bendrinamas turinys atnaujintas.',
    shareMsg3:
      'Nepavyko sugeneruoti bendrinimo nuorodos. Bandykite vėliau arba susisiekite su palaikymo tarnyba.',
    shareMsg4: 'Nepavyko atnaujinti bendros turinio. Bandykite vėliau arba susisiekite su pagalba.',
    shareTips: 'Jūsų PDF vertimas yra paruoštas! Pasidalykite juo su draugais.',
    start: 'Pradėkite nemokamą bandymą',
    thumbnail: 'Turinys',
    toast1: 'Kraunamas PDF. Prašome pabandyti vėliau.',
    toast2: 'PDF turinys apdorojamas. Dialogas šiuo metu nepalaikomas.',
    toast3: 'Atsiunčia. Pabandykite dar kartą po atsisiuntimo pabaigos.',
    toolbar: { Adjust: 'Pakeisti', autoFit: 'Automatinis pritaikymas' },
    trans: 'Vertimas',
    transSucc: 'Vertimas sėkmingas!',
    unLoginToast: 'Prisijunkite, kad naudotumėte šią funkciją.',
    uploadBtn: 'Įkelti',
    uploadErr: 'Failo įkėlimas nepavyko. Bandykite vėliau arba susisiekite su palaikymo tarnyba.',
    uploadErrSignUrl:
      'Nepavyko gauti įkėlimo URL. Bandykite vėliau arba susisiekite su palaikymo tarnyba.',
    uploadMsg1: 'Tempkite failą čia arba pakelkite ir paleiskite.',
    uploadMsg2: ' palaikomi failų tipai: PDF  |  Maksimalus failo dydis: 300MB',
    uploadMsg3: 'Spustelėkite, kad pasirinktumėte arba tempkite ir paleiskite failus čia.',
    uploading: 'Įkeliama',
    uploadingMsg: 'Įkeliama. Palaukite, prašome.',
    uploadingMsg1: 'Failas įkeliamas. Pabandykite vėliau.',
    uploadingMsg2: 'Failas šiuo metu yra konvertuojamas. Bandykite vėliau.',
    uploadingMsg3:
      'Konversijos eigos užklausa nepavyko. Bandykite vėliau arba susisiekite su palaikymo tarnyba.',
    uploadingMsg4:
      'Noam negali pasiekti vietinių failų. Prašome rankiniu būdu įkelti PDF failą vertimui.',
    uploadingMsg5: 'Nepavyko gauti failo URL. Bandykite vėliau arba susisiekite su pagalba.',
    video: 'vaizdo įrašas',
    vipBannerBtn: 'Atnaujinti',
    vipBannerTips: 'Jūs pasiekėte šio mėnesio PDF vertimo limitą.',
    webTrans: 'Pilnas kryžminis nuorodojimas',
  },
  pricing: {
    FAQ: 'DUK',
    FQAObj: {
      a1: 'Taip, Noam siūlo nemokamą planą, kuriuo galite pradėti naudotis iškart.',
      a2: 'Mes siūlome tris narystės planus: Pro, Pro+ ir Enterprise. Galite pasirinkti mokėti mėnesiui arba metams. Metinė sąskaita suteikia didelius taupymus.',
      a3: 'Visos funkcijos yra prieinamos abiejuose planuose. Pagrindinė skirtumas yra kaina: metinės prenumeratos iš viso kainuoja mažiau. Mėnesinės prenumeratos sąskaitomos kiekvieną mėnesį, o metiniai planai sąskaitomos kartą per metus.',
      a4: 'Jūs galite atšaukti savo prenumeratūrą bet kada „Paskyros nustatymuose“.',
      q1: 'Ar yra nemokama planas?',
      q2: 'Kokie kainodaros planai ir mokėjimo variantai yra prieinami?',
      q3: 'Kokia yra skirtumas tarp mėnesinio ir metinio prenumeratos?',
      q4: 'Kaip atšauku savo prenumeratą?',
    },
    around: 'Apie',
    billedMonthly: 'Sąskaita išrašoma mėnesiui',
    billedYearly: 'Sąskaita išrašoma kasmet',
    day: 'diena',
    desc: 'Palyginkite planus ir pasirinkite geriausią',
    detailedCompare: 'Palyginti planus',
    discount: '20% nuolaida',
    enterprise: {
      benefit1: 'Prioritetinė klientų palaikymo tarnyba',
      benefit2: 'Keli vartotojai',
      benefit3: 'Individualios Sprendimai',
      benefit5: 'Atsakingas sąskaitų vadovas',
      btn: 'Susisiekite su mumis',
      recommendText: 'Individualios planai (≥3 žmonės)',
      talkToUs: 'Susisiekite',
    },
    free: {
      benefit1: 'Tą pačią dieną 100 kartų tiesioginė vertimas',
      benefit2: 'Tinklalapio vertimas ir santrauka',
      benefit3: '30 paveikslėlių vertimai',
      benefit4: 'Video vertimas ir santrauka',
      benefit5: '10 PDF vertimai',
      benefit6: '5 000 žetonų',
      btn: 'Išbandyk nemokamai',
      recommendText: 'Nemokamas bandymas',
    },
    imageTranslation: 'Vaizdo vertimas',
    month: 'mėnuo',
    monthly: 'Mėnesinis',
    pageTitle: 'Kainodara',
    pdf: {
      chat: 'PDF pokalbio užklausos',
      maxPage: 'Maks. puslapių per PDF',
      translation: 'PDF vertimas',
    },
    preMonth: 'Per mėnesį',
    pro: {
      benefit1: 'Prioritetinė klientų pagalba',
      benefit2: '1 000 000 tokenų per mėnesį',
      benefit3: 'Svetainės vertimas ir santrauka',
      benefit4: '200 paveikslėlių vertimai',
      benefit5: 'Video vertimas ir santrauka',
      benefit6: '200 PDF vertimai',
      btn: 'Pradėti',
      recommendText: 'Labiausiai populiarus',
    },
    proPlus: {
      benefit1: 'Prioritetinė klientų palaikymo tarnyba',
      benefit2: '3 000 000 žetonų per mėnesį',
      benefit3: 'Svetainės vertimas ir santrauka',
      benefit4: '500 paveikslėlių vertimai',
      benefit5: 'Video vertimas ir santrauka',
      benefit6: '500 PDF vertimai',
      recommendText: 'Geriausia vertė',
    },
    video: { summary: 'Video Santrauka', translation: 'Vaizdo įrašų vertimas' },
    web: {
      contrastiveTranslation: 'Dviejų kalbų vertimas',
      dictionaryTranslation: 'Parinkties vertimas',
      hoverTranslation: 'Peruodimo vertimas',
      instantTranslation: 'Tarpinis vertimas',
      summary: 'Web puslapio santrauka',
    },
    yearly: 'Metinis',
  },
  privacy: {
    block1:
      'Noam ("Noam", "mes", "mūsų" arba "mus") gerbia jūsų privatumą ir įsipareigojo apsaugoti bet kokius duomenis, kuriuos gauname iš jūsų arba apie jus. Ši Privatumo politika aprašo mūsų praktikas, susijusias su asmeninių duomenų rinkimu arba naudojimu, kai naudojate mūsų svetainę, programas ir paslaugas (bendrai vadinamas „Paslaugos“). Ši Privatumo politika netaikoma turiniui, kurį tvarkome už mūsų verslo produktų klientų, pavyzdžiui, mūsų API. Šių duomenų naudojimas yra reglamentuojamas mūsų sutartimi su klientu, kuri apima prieigą prie šių produktų ir jų naudojimą.',
    block10:
      'Taikome komercialiai pagrįstas technines, administracines ir organizacines priemones, kad apsaugotume asmeninę informaciją tiek internete, tiek ne internete nuo praradimo, neteisėtos naudojimo, neleistino prieigos, atskleidimo, pakeitimo ar priešingų veiksmų. Tačiau nė vienas internetinis ar el. pašto perdavimas negali garantuoti visiškos saugumo ar tikslumo. Ypač el. laiškai, siunčiami mums arba iš mūsų, gali būti neapsaugoti. Todėl turėtumėte būti ypač atsargūs, nusprendžiant, kokios informacijos siųsti mums per paslaugą ar el. paštą. Be to, mes nesame atsakingi už bet kokį privatumo nustatymų ar saugumo priemonių trukdymą paslaugoje ar trečiųjų šalių svetainių saugumo nustatymuose ar saugumo priemonėse. Mes išlaikysime jūsų asmeninę informaciją tol, kol tai būtina, kad galėtume teikti jums paslaugas arba dėl kitų teisėtų verslo tikslų, pavyzdžiui, ginčų sprendimo, saugumo ir saugumo priežasčių arba įsipareigojimų įgyvendinimo įstatymų ir kitų teisės aktų laikymosi. Laikas, per kurį mes išlaikome asmeninę informaciją, priklausys nuo daugelio veiksnių, pavyzdžiui, informacijos kiekio, pobūdžio, jautrumo, galimų rizikų dėl neleistino naudojimo ar atskleidimo, tikslų, dėl kurių mes tvarkome informaciją, ir kitų teisės įpareigojančių apmąstymų.',
    block11:
      'Šią privatumo politiką galime atnaujinti laiką nuo laiko. Kai tai padarome, mes paskelbsime atnaujintą versiją šioje puslapyje, nebent teisės aktai nurodo kitaip.',
    block12:
      'Jeigu turite neišspręstų klausimų ar rūpesčių dėl šios Privatumo politikos, susisiekite su mūsų klientų aptarnavimo tarnyba. El. paštas:',
    block2: 'Mes renkame šiuos jūsų asmeninius duomenis („Asmeniniai duomenys“):',
    block3:
      'Jūsų teikta informacija: Kai sukuriate paskyrą naudotis mūsų paslaugomis arba bendraujate su mumis, mes renkame asmeninę informaciją taip:',
    block4:
      'Asmeninė informacija, kurią automatiškai gauname naudojant paslaugas: Kai jūs pasiekiate, naudojate ar bendraujate su paslaugomis, mes gauname šią informaciją apie jūsų pasiekimą, naudojimą ar sąveiką („Techninė informacija“):',
    block5: 'Mūsų gali naudoti asmeninę informaciją šiais tikslais:',
    block6:
      'Santrauka arba deidentifikuota informacija: Mes galime agreguoti arba deidentifikuoti asmeninę informaciją, kad užkirstume kelią jos naudojimui identifikavimo tikslais, ir naudoti tokią informaciją, kad analizuotume mūsų paslaugų veiksmingumą, tobulinėtume ir pridedėtume funkcijas mūsų paslaugose, atliktume tyrimus ir panašiuosius tikslus. Be to, mes galime analizuoti bendrą mūsų paslaugų vartotojų elgesį ir charakteristikas bei dalintis agreguotą informacija su trečiosiomis šalimis, publikuoti tokią agreguotą informaciją arba ją padaryti bendrai prieinamą. Mes galime rinkti agreguotą informaciją per paslaugas, per slapukus ir per kitus šio Privatumo politikoje aprašytus būdus. Mes saugosime ir naudojame deidentifikuotą informaciją anonimišką arba deidentifikuotą pavidalu ir nebusime bandomi atstatyti toksos informacijos identifikaciją, nebent tai yra įpareigojama įstatymu.',
    block7:
      'Tam tikrais atvejais mes galime pateikti jūsų asmeninę informaciją trečiosioms šalims be papildomos jums pranešimo, nebent tai yra įpareigojama įstatymu:',
    block8:
      'Priklausomai nuo jūsų geografinės padėties, asmenys Europos ekonominės erdvėje, Jungtinėje Karalystėje ir visame pasaulyje gali turėti tam tikras įstatymų numatytas teises dėl savo asmeninių duomenų. Pavyzdžiui, jūs galite turėti teisę:',
    block9:
      'Paslauga gali turėti nuorodas į kitas svetaines, kurias nepriežiūri ar nekontroliuoja Noam, įskaitant socialinių tinklų paslaugas („Trečiųjų šalių svetainės“). Informacija, kurią pasidalijate su Trečiųjų šalių svetainėmis, bus reglamentuojama konkrečiomis Trečiųjų šalių svetainių privatumo politikomis ir paslaugų sąlygomis, o ne šia Privatumo politika. Mes teikiame šias nuorodas dėl patogumo ir nepažymime savo patvirtinimo ar šių svetainių peržiūros. Norėdami gauti informacijos apie jų privatumo politikas ir sąlygas, tiesiogiai susisiekite su Trečiųjų šalių svetainėmis.',
    subBlock1:
      'Paskyros informacija: Kai sukuriate paskyrą mūsų platformoje, mes renkame paskyrai susijusią informaciją, įskaitant jūsų vardą, kontaktinę informaciją, paskyros prisijungimo duomenis, mokėjimo kortelės informaciją ir sandorių istoriją („Paskyros informacija“).',
    subBlock10: 'Paslaugų teikimas, valdymas, priežiūra ir(ar) analizė;',
    subBlock11: 'Komunikavimas su jumis',
    subBlock12: 'Naujų produktų ir paslaugų kūrimas;',
    subBlock13:
      'Prevencija nuo sukčiavimo, nusikalstamų veiksmų ar paslaugų netinkamo naudojimo, taip pat IT sistemų, architektūros ir tinklų saugumo apsauga;',
    subBlock14: 'Verslo perkėlimų vykdymas;',
    subBlock15:
      'Atsisakymas nuo teisinių įsipareigojimų ir teisinių procesų, mūsų teisių, privatumo, saugumo ar turtas, taip pat mūsų filialų, jūsų ar kitų trečiųjų šalių teisių, privatumo, saugumo ar turtas apsauga.',
    subBlock16:
      'Tiekėjai ir paslaugų teikėjai: Norėdami padėti mums patenkinti verslo veiklos poreikius ir vykdyti tam tikras paslaugas bei funkcijas, mes galime pateikti asmeninę informaciją tiekėjams ir paslaugų teikėjams, įskaitant hostingo paslaugų teikėjus, debesies paslaugų teikėjus ir kitus informacinės technologijos paslaugų teikėjus, el. pašto komunikacijos programinę įrangą, internetinės analizės paslaugų teikėjus ir pan. Šie partneriai bus prieinami prie asmeninės informacijos, ją tvarkys arba saugos tik pagal mūsų nurodymus atliekant savo pareigas mums.',
    subBlock17:
      'Verslo perkėlimai: Jeigu mes dalyvaujame strateginiuose sandoruose, reorganizacijose, bankrotuose, bankroto įsigijimuose arba paslaugų perėjime kitam teikėjui (bendrai vadinami „Sandarais“), jūsų asmeninė informacija ir kita informacija gali būti bendrinama su sandorių partneriais ir kitais šalių, padedančių vykdyti Sandorus, dėl尽职调查ir perduota kaip Sandorių dalis kartu su kitais turtu pakeitėjui arba filialinei įmonei.',
    subBlock18:
      'Teisiniai reikalavimai: Mes galime dalintis jūsų asmeninėmis informacija su vyriausybės institucijomis, pramonės bendraamžiais ar kitais trečiosiomis šalimis, įskaitant jūsų sąveikos informaciją su mūsų paslaugomis: (1) jei tai yra įpareigojimas pagal įstatymus arba jei mes manome, kad toks veiksmas yra būtinas norint įvykdyti teisinį įsipareigojimą; (2) norint apsaugoti ir ginti mūsų teises ar turtą; (3) jei mes vienpusiai nustatome, kad buvo pažeistas mūsų sąlygos, politikos ar įstatymai; (4) norint aptikti arba užkirsti kelią sukčiavimams ar kitoms nelicitetiems veiksmams; (5) norint apsaugoti mūsų produktus, darbuotojus arba vartotojus, taip pat visuomenės saugumą, apsaugą, vientisumą; arba (vi) norint ginti nuo teisinės atsakomybės.',
    subBlock19:
      'Prieikite prie savo asmeninių duomenų ir informacijos apie tai, kaip jie apdorojami.',
    subBlock2:
      'Naudodami mūsų paslaugas, mes surenkame asmeninę informaciją iš jūsų įvestų duomenų, įkeltų failų arba mums pateiktos atsiliepimos („Turinys“).',
    subBlock20: 'Prašome ištrinti jūsų asmeninę informaciją iš mūsų įrašų.',
    subBlock21: 'Patikrinkite arba atnaujinkite savo asmeninę informaciją.',
    subBlock22: 'Perkelkite savo asmeninę informaciją trečiosioms šalims (duomenų perkeliamumas).',
    subBlock23: 'Apribokite, kaip mes tvarkome jūsų asmeninę informaciją.',
    subBlock24:
      'Atšaukite savo sutikimą — kai mes remiamės sutikimu kaip teisiniu pagrindu duomenų apdorojimui, jūs galite atšaukti savo sutikimą bet kada.',
    subBlock25: 'Prieštarauti būdu, kaip mes tvarkome jūsų asmeninę informaciją.',
    subBlock26: 'Mūsų paslaugų tobulinimas ir tyrimų vykdymas;',
    subBlock3:
      'Komunikacinė informacija: Jeigu siųsite mums pranešimus, mes surinksime jūsų vardą, kontaktinę informaciją ir pranešimų turinį („Komunikacinė informacija“).',
    subBlock4:
      'Socialinio tinklo informacija: Mes turime puslapius tokiuose socialiniuose tinkluose kaip Instagram, Facebook, Medium, Twitter, YouTube ir LinkedIn. Kai bendraujate su mūsų socialinio tinklo puslapiais, mes surenkame asmeninę informaciją, kurią nusprendžiate mums pateikti, pavyzdžiui, savo kontaktinę informaciją („Socialinė informacija“). Be to, įmonės, veikiančios mūsų socialinio tinklo puslapius, gali mums pateikti agreguotą informaciją ir analizę apie mūsų socialinio tinklo veiklą.',
    subBlock5:
      'Žurnalo duomenys: Informacija, kurią automatiškai siunčia jūsų naršyklė naudojant mūsų paslaugas. Žurnalo duomenys apima jūsų interneto protokolo (IP) adresą, naršyklės tipą ir nustatymus, jūsų užklausų datą ir laiką bei tai, kaip jūs sąveikaujate su mūsų svetaine.',
    subBlock6:
      'Naudojimo duomenys: Mes galime automatiškai rinkti informaciją apie jūsų paslaugos naudojimą, pavyzdžiui, peržiūrimo ar su kuriuo sąveikaujate turinio tipus, naudojamas funkcijas, atliktas veiksmus, taip pat jūsų laiko zoną, šalį, prieigos datą ir laiką, vartotojo agentą ir versiją, kompiuterio arba mobiliausio įrenginio tipą bei kompiuterio ryšį.',
    subBlock7:
      'Įrenginio informacija: Tai apima įrenginio pavadinimą, operacinę sistemą, įrenginio identifikatorių ir jūsų naudojamą naršyklę. Surinkta informacija gali priklausyti nuo jūsų naudojamo įrenginio tipo ir jo nustatymų.',
    subBlock8:
      'Slapukai: Mes naudojame slapukus, kad galėtume veikti ir tvarkyti savo paslaugas bei pagerinti jūsų patirtį. „Slapukas“ yra informacija, kurią jūsų lankoma svetainė siunčia jūsų naršyklei. Jūs galite nustatyti savo naršyklę taip, kad ji priimtų visus slapukus, atmestų visus slapukus arba praneštų jums, kai siunčiamas slapukas, kad kiekvieną kartą galėtumėte nuspręsti, ar jį priimti. Tačiau slapukų atmetimas gali neleisti jums naudotis tam tikromis svetainės sritimis ar funkcijomis arba neigiamai paveikti jų rodymą arba veikimą. Daugiau informacijos apie slapukus galite rasti svetainėje All About Cookies.',
    subBlock9:
      'Analitika: Mes galime naudoti įvairius internetinius analitikos produktus, kurie naudoja slapukus, kad padėtų mums analizuoti, kaip naudotojai naudoja mūsų paslaugas, ir pagerinti jūsų patirtį naudojantis paslaugomis.',
    subTitle1: 'Asmesio informacijos, kurią mes renkame',
    subTitle2: 'Kaip naudojame asmeninę informaciją',
    subTitle3: 'Asmeninės informacijos atskleidimas',
    subTitle4: 'Jūsų teisės',
    subTitle5: 'Nuorodos į kitas svetaines',
    subTitle6: 'Informacijos saugumas ir išlaikymas',
    subTitle7: 'Privatumo politikos modifikavimas',
    subTitle8: 'Kaip susisiekti su mumis',
    title: 'Privatumo politika',
    updateTime: 'Atnaujinta: 2024 m. kovo 15 d.',
  },
  privacyCollectionPanel: {
    acceptBtn: 'Priimti viską',
    text: 'Norėdami pagerinti jūsų patirtį, mes naudojame slapukus, kad personalizuotume turinį ir paslaugas.',
    title: 'Šis tinklalapis naudoja slapukus',
  },
  slogen: 'Paprasčiausias AI pagalbininkas',
  stripe: {
    contact: 'Susisiekite su mumis el. paštu contact@noam.tools dėl bet kokios klausimo!',
    fail: {
      btn: 'Bandyti dar kartą',
      text1: 'Negalime apdoroti jūsų mokėjimo.',
      text2: 'Patikrinkite savo ryšį ir bandykite dar kartą.',
      title: 'Mokėjimas nepavyko',
    },
    succ: {
      btn: 'Eikime',
      text1: 'Sveiki atvykę į Noam',
      text2: 'pradėkime!',
      title: 'Sveikinimai',
    },
  },
  terms: {
    block1: 'Dėkojame, kad naudojatės Noam!',
    block10:
      '(a) Mokesčiai ir sąskaitų išrašymas. Jūs sumokėsite visus mokesčius („Mokesčiai“) pagal kainodarą ir sąlygas tinkamoje kainodaros puslapyje arba kaip susitarta raštu tarp mūsų. Mes išsaugome teisę pataisyti kainodaros klaidas arba klaidų, net jei išrašėme sąskaitas arba gavome mokėjimą. Jūs teisite pilną ir tikslią sąskaitų informaciją, įskaitant galiojantį ir autorizuotą mokėjimo būdą. Mes įkelsime jūsų mokėjimo būdą periodiškai pagal susitarimą, tačiau galime pagrįstai pakeisti sąskaitų išrašymo datą. Jūs autoryzujete „Noam“, jos filialus ir trečiųjų šalių mokėjimų apdorojimo paslaugas įkelti jūsų mokėjimo būdą. Jei jūsų mokėjimas nepavyks, mes suteiksime jums rašytinį pranešimą ir galime sustabdyti prieigą prie paslaugos iki mokėjimo gavimo. Išskyrus atvejus, kurie kitaip nurodyti šiame susitarime, mokėjimai nėra grąžinami.',
    block11:
      '(b) Mokesčiai. Jei nenurodyta kitaip, mokslai neįtraukia jokių federalinių, valstybinių, vietos ar užsienio mokesčių, tarifų ar panašių apmokestinimų („mokesčių“). Jūs esate atsakingas už visus mokesčius, susijusius su jūsų pirkimais, išskyrus mokesčius, pagrįstus mūsų grynais pajamais, dėl kurių mes jums išsiųsime sąskaitą. Jūs sutinkate nedelsiant sumokėti šiuos mokesčius, pateikti mums teisėtai galiojančius privatumo teiginius, gauti reikalingus sutikimus dėl to duomenų tvarkymo, ir jam garantuojate, kad tvarkote šiuos duomenis pagal galiojančius įstatymus.',
    block12:
      '(c) kainų keitimai. Mes galime pakeisti savo kainas pranešdami jums per jūsų paskyrą ir (arba) mūsų internetinį puslapį. Kainų padidinimai įsigalioja iškart po paskelbimo. Bet kokie kainų pokyčiai bus taikomi jūsų paskyros mokesčiams po pokyčio įsigaliojimo datos.',
    block13:
      '(d) Ginčai ir neatidėlioti mokėjimai. Jeigu norite ginčyti bet kokius mokestis ar mokesčius, prašome susisiekti su contact@noam.tools per trisdešimt (30) dienų nuo sąskaitos išrašymo datos.',
    block14:
      '(e) Nemokama naudojimasis. Jūs negalite kurti kelių paskyrų, kad gautumėte nemokamus kreditus. Jei mes nustatysime, kad jūs naudojatės nemokamais kreditais ne iš geros valios, mes galime jums parodyti standartines mokesčias arba nutraukti prieigą prie paslaugos.',
    block15:
      '(a) Konfidencialumas. Jūs galite turėti prieigą prie Noamo konfidencialios informacijos. Konfidencialią informaciją galite naudoti tik pagal šiuos sąlygas, siekiant naudotis paslauga. Jūs neturite atskleisti konfidencialios informacijos jokiam trečiajam asmeniui, o konfidencialią informaciją turite saugoti ne mažiau tvarkingai, nei saugote savo panašią konfidencialią informaciją, bent jau protingai. Konfidencialia informacija yra ne vieša informacija, kurią Noamas nurodo kaip konfidencialią arba kurią protingai būtų laikoma konfidencialią esant konkretiems aplinkybėms, įskaitant programinės įrangos, specifikacijų bei kitos ne viešos verslo informacijos. Konfidencialia informacija neįtraukia informacijos, kuri: (1) tampa bendrai prieinama visuomenei ne dėl jūsų kaltės; (2) buvo jūsų rankose be jokios konfidencialumo įsipareigojimo prieš ją gavus pagal šiuos sąlygas; (3) jums teisėtai atskleista trečiuoju asmeniu be jokios konfidencialumo įsipareigojimo; arba (4) jūsų nepriklausomai sukurtas be konfidencialios informacijos naudojimo. Konfidencialią informaciją galite atskleisti, jei tai reikalauja įstatymas, teismas arba kitas vyriausybės įsakymas, tačiau turite Noamui pateikti išankstinį rašytinį pranešimą protingu būdu ir, kiek įmanoma, padaryti protingus pastangas apriboti atskleidimo apimtį, įskaitant pagalbą mums prieštarauti atskleidimo prašymams.',
    block16:
      '(b) Saugumas. Jūs turite įgyvendinti pagrįstas ir tinkamas priemones, kad padėtumėte apsaugoti prieigą prie Paslaugos ir jos naudojimą. Jei aptinkate bet kokias pažeidimus ar saugumo spragas, susijusias su Paslaugos naudojimu, turite nedelsiant susisiekti su Noamu ir pateikti šių pažeidimų ar spragų detalės.',
    block17:
      '(c) Asmens duomenų tvarkymas. Jeigu naudojate paslaugą asmens duomenų tvarkymui, turite pateikti teisinis pagrįstus privatumo teiginius ir gauti reikalingus sutikimus dėl toks duomenų tvarkymo, ir įsipareigojate mums, kad tvarkote šiuos duomenis pagal galiojančius įstatymus.',
    block18:
      '(a) Nutraukimas; Sustabdymas. Šie sąlygos įsigalioja nuo jūsų pirmojo paslaugos naudojimo ir galios iki nutraukimo. Jūs galite nutraukti šias sąlygas bet kada ir bet kokia priežastimi nustatydami paslaugos ir turinio naudojimą. Mes galime nutraukti šias sąlygas su ankstesniu pranešimu bet kokia priežastimi. Mes galime nedelsiant nutraukti šias sąlygas pranešdami jums, jei jūs reikšmingai pažeidžiate 2 skyrių (Naudojimo reikalavimai), 5 skyrių (Konfidencialumas, saugumas ir duomenų apsauga), 8 skyrių (Ginčų sprendimas) arba 9 skyrių (Bendrieji sąlygos), arba jei mūsų santykiai su bet kuriuo trečiosios šalies technologijų tiekėju, kurio valdymo ne turime, pasikeičia, arba dėl teisės įgyvendinimo arba vyriausybės prašymų. Mes galime sustabdyti jūsų prieigą prie paslaugos, jei jūs nesilaikote šių sąlygų, arba jei jūsų naudojimas kelia saugumo riziką mums arba bet kuriai trečiosiai šaliai, arba jei mes įtariame, kad jūsų naudojimas yra apgaulingas arba gali pateikti mus arba bet kurią trečiosią šalį į atsakomybę.',
    block19:
      '(b) Nutraukimo pasekmės. Nutraukus sutartį, jūs nenorėsite naudotis Paslaugomis ir nedelsiant grąžinsite arba sunaikinsite bet kokias konfidencialias informacijas, kaip nurodėme mes. Šių sąlygų nuostatos, kurios savo prigimtimi turėtų išlikti po nutraukimo arba galiojimo termino pabaigos, įskaitant, bet neapsiribojant 3 ir 5–9 skyriais, išliks.',
    block2:
      'Šie naudojimo sąlygos taikomos jūsų naudojimui Noam paslaugų, įskaitant mūsų programinės įrangos sąsajas, programinę įrangą, įrankius, kūrėjų paslaugas, duomenis, dokumentaciją ir svetainę (bendromis pastabomis vadinamas „Paslaugos“). Naudodamiesi mūsų Paslaugomis, jūs sutinkate laikytis šių sąlygų. Mūsų Privatumo politika paaiškina, kaip mes renkame ir naudojame asmeninius duomenis.',
    block20:
      'Atsakomybė už atlyginimą. Jūs apsaugosite, atlyginsite ir laikysite mus, mūsų filialus bei mūsų personalą neatsakingais už bet kokius skundus, nuostolius ir išlaidas (įskaitant advokatų mokestis), kilusius dėl arba susijusius su jūsų paslaugos naudojimu, įskaitant jūsų turinį, jūsų naudojimą paslaugai susijusių produktų ar paslaugų bei jūsų pažeidimą šių sąlygų arba taikomųjų įstatymų.',
    block21:
      '(b) Atleidimai nuo atsakomybės. Paslauga teikiama „kaip yra“. Iki to lygio, kiek leidžia teisė, mes, mūsų filialai ir licencijonuotojai nevykdo jokių pareiškimų ar garantijų bet kokio tipo dėl Paslaugos ir nevykdo jokių garantijų, įskaitant, bet neapsiribojant, prekių pardavimo galimybės, tinkamumo konkrečiam tikslui, patenkinamos kokybės, nepažeidimo autorių teisių ir tyčios naudojimo garantijomis, taip pat jokiomis garantijomis, kylančiomis iš sandorių vykdymo ar prekybos praktikos.',
    block22:
      '(c) Atlyginimo pareigos ribojimas. Ne mes, nei mūsų susiję įmonės, nei mūsų licenciarai nebus atsakingi už jokias netiesiogines, atsitiktines, specialias, pasekmingas arba numalojančias žalás, įskaitant pelno nuostolius, reputacijos nuostolius, naudojimo nuostolius, duomenų nuostolius ar kitus nematerialius nuostolius, net jei buvome informuoti apie tokių žalų galimybę. Šių sąlygų pagalba mūsų bendra atsakomybė neviršys sumos, kurią jūs sumokėjote už paslaugą per dvylika (12) mėnesių prieš reikalavimą, arba šimto JAV dolerių (100 USD), priklausomai nuo to, kuris sumą yra didesnė. Šio skyriaus apribojimai taikomi tiek, kiek leidžia taikoma teisė.',
    block23:
      'Sąlygos ir jūsų paslaugų naudojimas yra reglamentuojami JAV įstatymais, išskyrus JAV teisės konfliktų taisykles. Jūsų programinės įrangos naudojimas taip pat gali būti reguliuojamas kitais vietos, valstijos, nacionaliniais ar tarptautiniais įstatymais. Bet kokia teisinė byla ar procesas, susijęs su šiomis sąlygomis, bus pateiktas tik JAV teismuose, ir jūs sutinkate paklusti šių teismų asmeninei jurisdikcijai.',
    block24:
      'Šalių santykiai. Noamas ir jūs esate nepriklausomi rangovai, ir nė viena šalis neturi teisės atstovauti kitai šaliai, jos įpareigoti ar prisiimti įsipareigojimus už ją be kitos šalies anksčiau išrašytos sutikimo.',
    block25:
      '(b) Prekių ženklų naudojimas. Jūs negalite naudoti Noam arba jokios jos filialo vardo, logotipų ar prekių ženklų be mūsų anksčiau pateiktos rašytinės sutikimo.',
    block26:
      'Jei bet kuri šių sąlygų nuostatą nustatytume kaip neteisėtą, nelicencijuotą ar netaikomą, likusios nuostatos išlieka visais galiomis ir įsigalioja visiškai.',
    block3:
      'Jei jūs esate jaunesnis nei 18 metų, norėdami naudotis paslauga, turite gauti leidimą iš savo tėvų ar teisinių globėjų. Jei naudojatės paslauga atstovaujant kitai asmeniui ar juridiniam asmeniui, turite būti įgalintas priimti šiuos sąlygas jų vardu. Registruodami sąskaitą, turite pateikti tikslų ir išsamią informaciją. Jūs neturite perduoti savo prieigos duomenų ar sąskaitos jokiam asmeniui už jūsų organizacijos ribų, ir jūs esate atsakingas už visas veiklas, atliekamas naudojant jūsų prieigos duomenis.',
    block4:
      '(a) Paslaugos naudojimas. Jūs galite pasiekti paslaugą pagal šiuos sąlygas, ir mes suteikiame jums neekskluzinę teisę naudotis paslauga. Naudodamiesi paslauga, jūs laikysitės šių sąlygų ir visų galiojančių įstatymų. Mes ir mūsų filialai turime visas teises, titulą ir interesus į paslaugą.',
    block5:
      '(b) Atsiliepimai. Mes sveikiname atsiliepimus, komentarus, idėjas, pasiūlymus ir pataisas. Jei jūs pateiksite tokį turinį, mes galime jį naudoti be jokių apribojimų ir be jums sumokėjimo kompensacijos.',
    block6:
      '(c) Ribojimai. Jūs negalite: (1) naudotis paslauga būdu, kuris pažeidžia bet kokius kitų teises, jų pavogsta ar pažeidžia; (2) atvirkštinio inžinerijos būdu tirti, dekompiliuoti, disasembliuoti, versti ar kitaip bandyti atrasti paslaugos modelių, algoritmų ir sistemų šaltinio kodą ar pagrindinius komponentus (nebent tokie ribojimai yra draudžiami taikomuoju įstatymu); (3) naudotis paslaugos išvestimi kuriant modelius, konkuruojančius su Noamu; (4) išgauti duomenis arba išvestį iš paslaugos naudojant bet kokius automatizuotus ar programavimo metodus, nebent tai leidžiama per API, įskaitant duomenų surinkimą (scraping), internetinių duomenų rinkimą arba duomenų išgavimą; (5) pristatyti paslaugos išvestį kaip dirbtinai sugeneruotą, kai tai nėra tiesa, arba kitaip pažeisti mūsų naudojimo taisykles; (6) pirkti, pardavinėti ar perduoti API raktus be mūsų išankstinio sutikimo; arba (7) pateikti mums bet kokios asmeninės informacijos apie vaikus, kurių amžius yra mažiau nei 13 metai, arba taikomąjį skaitmeninio sutikimo amžių. Jūs turite laikytis bet kokio greičio ribojimo ir kitų reikalavimų mūsų dokumentacijoje.',
    block7:
      '(d) Trečiųjų šalių paslaugos. Bet kokia trečiųjų šalių programinė įranga, paslaugos ar kiti produktai, susiję su Paslauga, yra reglamentuojami jų pačių sąlygomis, ir mes neatsakome už trečiųjų šalių produktus.',
    block8:
      'Jūsų turinys. Jūs galite pateikti įvesties duomenis („Įvestis“) paslaugai ir gauti išvesties duomenis („Išvestis“), kuriuos generuoja ir grąžina pagal Įvestį (bendrai vadinami „Turiniu“). Tarp šalių, ir kiek leidžia taikomoji teisė, Jūs esate visų Įvesties savininkas. Noam gali naudoti Turinį paslaugai teikti ir palaikyti, laikytis taikomųjų įstatymų ir vykdyti mūsų politiką. Jūs esate atsakingas už Turinį, įskaitant užtikrinimą, kad jis nepažeidžia jokių taikomųjų įstatymų ar šių sąlygų.',
    block9:
      '(b) Tikslumas. Dirbtinis intelektas ir mašininis mokymasis yra greitai besivystantys tyrimų srautai. Mes nuolat stengiamės tobulinti savo paslaugą, kad ji būtų tiksliau, patikimesnė, saugesnė ir naudingesnė. Atsižvelgiant į mašininio mokymosi tikimybinę prigimtį, naudojant mūsų paslaugą kai kuriais atvejais gali būti gaunami neteisingi rezultatai, kurie negali tiksliai atspindėti tikrų asmenų, vietų ar faktų. Jūs turite tinkamai įvertinti bet kokio rezultato tikslumą pagal savo naudojimo atvejį, įskaitant rankinį rezultatų peržiūrą.',
    subTitle1: 'Registracija ir prieiga',
    subTitle10: 'Atskiriamumas',
    subTitle2: 'Naudojimo reikalavimai',
    subTitle3: 'Turinys',
    subTitle4: 'Mokestis ir apmokėjimas',
    subTitle5: 'Konfidencialumas, Saugumas ir Duomenų Apsauga',
    subTitle6: 'Terminas ir nutraukimas',
    subTitle7: 'Atlyginimas; Atsisakymai; atsakomybės ribojimas',
    subTitle8: 'Tvirtinantis teisės aktas ir jurisdikcija',
    subTitle9: 'Bendrieji sąlygos',
    title: 'Paslaugų sąlygos',
    updateTime: 'Atnaujinta: 2024 m. kovas 15 d.',
  },
  trialModal: {
    btn: 'Pradėkite dabar (tik 0,99 USD)',
    chat: 'ChatPDF',
    desc1: 'Po jūsų bandymo periodo jums bus taikoma 180 USD metinė mokestis',
    desc2: 'Atšaukti bet kada',
    focus: 'Susitelkimas',
    hover: 'Užvedimo vertimas',
    image: 'Vaizdo vertimas',
    installBtn: 'Įdiekite dabar, kad gautumėte savo dovaną',
    memo: 'Mėgstamiausių tvarkymas',
    pdf: 'PDF lygiagretusis vertimas',
    realtime: 'Tą pačią akimirką vertimas',
    select: 'Žodžių pasirinkimo vertimas',
    title: 'Sveikinimo dovanėlė',
    trialText: '7 dienų bandymas',
    video: 'Video vertimas',
    videoSummary: 'Video santrauka',
    web: 'Lygiagretus vertimas',
    webSummary: 'Web santrauka',
  },
  upgradeModal: {
    btn: 'Atnaujinkite dabar',
    chat: {
      free: 'Jūs pasiekėte „ChatPDF“ limitą',
      pro: 'Jūs pasiekėte šio mėnesio ChatPDF limitą',
    },
    contactStr: 'Palaukite kito atstatymo, arba susisiekite su mumis adresu contact@noam.tools.',
    limitAlertStr: 'Jūs pasiekėte nemokamo plano limitą. Atnaujinkite, kad tęstumėte.',
    more: 'Peržiūrėti planus',
    pageLimit: { free: 'Jūs pasiekėte PDF puslapių limitą' },
    title: 'Priminimas',
    upgradeAlertStr: 'Jūs pasiekėte nemokamo plano limitą. Atnaujinkite, kad tęstumėte.',
    upload: {
      free: 'Jūs pasiekėte savo PDF vertimo limitą',
      pro: 'Jūs pasiekėte šio mėnesio PDF vertimo limitą',
    },
  },
  welfare: {
    newUser: {
      joinBtn: 'Prisijunkite dabar',
      label: 'Naujų vartotojų privalumai:',
      remain: 'Liko tik 30',
      text: 'Tik 100 vietų! Užimkite savo dabar!',
    },
  },
  aiPdfTranslator: {
    title: 'Nemokamas AI PDF vertėjas: Versti PDF su palyginimu bet kuriomis kalbomis',
    desc: 'Lengvai versti PDF failus į bet kurias kalbas su AI. Lygykite originalų ir išverstą tekstą šalia einančiais stulpeliais, greitai ir nemokamai.',
    keywords: 'GPT-4、AI Asistentas、Vertimas、Santrauka、Fokas、ChatPDF、Notatka、efektyvumas',
    sourceToTarget: {
      title: 'Nemokamas PDF vertimo įrankis: versti {{source}} į {{target}} nemokamai',
      desc: 'Verstykite savo PDF failus iš bet kurios kilmės kalbos į norimą kalbą nemokamai. Greita, tikslus ir saugus PDF vertimas, pagrįstas pažangia AI.',
    },
    headerIntroduce: {
      title: 'Noam: Daugiau nei tik internetinė vertimas',
      introduce1: {
        title: 'Noam · PDF skaitytuvas',
        desc: '✨Viena šalia kita vertimas + AI klausimai ir atsakymai. Greitai ir tiksliai versti PDF failus į norimą kalbą. Laisvai klauskite apie turinį, kad gautumėte platesnį supratimą apie savo PDF failus.',
      },
      introduce2: {
        title: 'Noam · Šalia viena kita vertimo plėtinys',
        desc: '👏Išspręskite visas savo tinklalapių vertimo problemas:',
        detail1: { title: 'Web puslapio vertimas:', desc: 'Viena šalia kita dvikalbis vaizdas' },
        detail2: { title: 'Žodžio vertimas:', desc: 'Per vieną spustelėjimą greita vertimas' },
        detail3: { title: 'Tarpinis vertimas:', desc: 'Greitai išverstite žodžius arba sakinį.' },
        detail4: { title: 'Vaizdo vertimas:', desc: 'Pakeiskite paveikslėlius išverstais.' },
        detail5: {
          title: 'Vaizdo įrašo vertimas:',
          desc: 'Dviejų kalbų subtitrai geresniam peržiūrimui.',
        },
        footer: 'Patirkite daugiau AI varomų skaitymo funkcijų protingesniam vertimui!',
      },
    },
    subtitle: 'PDF vertimas internetu nemokamai',
    introduce: {
      module1: {
        detail1: {
          title: 'Tikslaus Laiko Kelyje Prieš Kelyje PDF Vertimas',
          desc1:
            'Tą pačią akimirką rodykite originalų ir išverstą turinį sinchronizuotame, šalia vienas kito išdėstyme',
          desc2: 'Lengvai palyginkite abi versijas su sinchronizuotu slankimu',
          desc3: 'Laikykite identišką formatavimą, kad užtikrintumėte vientisą skaitymo patirtį',
        },
        detail2: {
          title: 'Tikslus turinio suderinimas ir patvirtinimas',
          desc1: 'Puikus šaltinio ir išversto teksto suderinimas lengvai patikrinti',
          desc2: 'Kiekvienas turinio segmentas tiksliai sutampa abiejuose versijose',
          desc3:
            'Greitai aptikti ir išspręsti vertimo neatitikimus, kad gautumėte patikimus rezultatus',
        },
      },
      module2: {
        detail1: {
          title: 'Keli pažengti AI modeliai tiksliai vertimui',
          desc1: 'Pasirinkite iš pirmaujančių AI modelių, kad atitiktumėte savo vertimo poreikius',
          desc2: 'užtikrinti optimalų rezultą įvairių dokumentų tipų ir pramonės šakų atveju',
          desc3: 'Lankstūs modelio parinktys suteikia pritaikytus sprendimus kiekvienam scenarijui',
        },
        detail2: {
          title: 'Pažengta AI vertimas kiekvieno turinio tipo',
          desc1: 'Mūsų stiprus AI modelis užtikrina didelę tikslumą ir natūralų kalbos supratimą',
          desc2: 'Lengvai tvarko techninius, akademinius ir kūrybinius dokumentus',
          desc3: 'Suteikia patikimus rezultatus visoms jūsų vertimo poreikiam',
          desc4: 'Intelektualus prisitaikymas prie skirtingų turinio tipų optimaliai veikimui',
        },
      },
      module3: {
        detail1: {
          title: 'Intelektualinė dokumentų sąveika',
          desc1:
            'Be jokios pastangos bendraukite su savo PDF ir prezentacijų failais naudojant pažangią AI',
          desc2: 'Tuoj pat užduokite klausimus apie dokumento turinį ir gausite tikslų atsakymų',
          desc3: 'Greitai generuokite trumpus santraukas ilgiems dokumentams',
        },
        detail2: {
          title: 'Glybiantis turinio analizė ir nesuvokiamoji integracija',
          desc1:
            'Išskirkite pagrindinę informaciją ir analizuokite sudėtingus duomenis naudojant AI pagrįstą supratimą',
          desc2: 'Gaukite įžvalgas į techninius, akademinius ar kūrybinius medžiagus',
          desc3:
            'Nepriekaištingai integruojasi su mūsų PDF verčiu, sudarydamas visą dokumentų valdymo sprendimą',
        },
      },
      module4: {
        detail1: {
          title: 'Virš PDF vertimo: Visas-i-vienas tinklalapių vertimo sprendimas',
          desc: 'Apskaičiuokite mūsų galingą šalia šalia esančią vertimo plėtinį, sukurtą kiekvienam interneto skaitymo scenarijui.',
          desc1:
            'Puslapio vertimas: mėgaukitės dvikalbiu turiniu su sinchronizuotu šalia esančiu rodymu',
          desc2: 'Žodžio vertimas: Akimirksniu išverstite pažymėtus žodžius vienu spustelėjimu',
          desc3:
            'Tą pačią akimirką vertimas: Versti bet kokį tekstą arba sakinį akimirkyje greitam supratimui',
          desc4:
            'Paveikslėlių vertimas: Automatiškai pakeiskite originalius paveikslėlius versti versijomis',
          desc5:
            'Vaizdo įrašų vertimas: žiūrėkite vaizdo įrašus su dviejų kalbų subtitrais, kad patirtis būtų geresnė',
        },
      },
    },
    question: {
      title: 'Daugiausiai užduodami klausimai',
      answer1: {
        title: 'Ar „Noam PDF Translator“ yra nemokamas naudoti PDF failų vertimui?',
        content:
          'Taip, jūs galite versti PDF failus nemokamai naudodami Sider PDF Translator! Mes siūlome nemokamą kvotą 5000 žetonų, kuri pakanka versti daugumą rinkoje dažniausiai randamų PDF dokumentų. Jei turite versti didesnius failus arba jums reikalingos pažangios funkcijos, galite pasirinkti atnaujinti į mūsų premium planus, kad gautumėte dar daugiau galimybių.',
      },
      answer2: {
        title: 'Kiek tikslus yra „Noam PDF Translator“?',
        content:
          'Noam PDF vertėjas teikia labai tikslų vertimą, naudojant pažangią AI technologiją ir giliai suprantant jūsų dokumentų kontekstą. Nors nė vienas automatizuotas vertimas nėra tobulas, mūsų šalia vienas kito rodymas leidžia lengvai peržiūrėti ir patobulinti kiekvieną vertimą, užtikrinant, kad galutinis rezultatas atitiktų jūsų kokybės lūkesčius. Patirkite patikimą ir tikslų PDF vertimą su Noam.',
      },
      answer3: {
        title: 'Ar galiu versti nuskenuotus PDF failus?',
        content:
          'Taip, jūs galite versti nuskaitytus PDF failus naudojant mūsų integruotą OCR (Optinės simbolių atpažinimo) technologiją. Mūsų sistema automatiškai išskiria tekstą iš nuskaitytų dokumentų ir paveikslėlių pagrįstų PDF failų, tada verčia turinį jums. Tai užtikrina, kad net neredaguojami arba tik paveikslėlių PDF failai gali būti tiksliai versti.',
      },
      answer4: {
        title: 'Kiek laiko užtrunka vertimas?',
        content:
          'Vertimas yra greitas ir efektyvus – dauguma dokumentų apdorojama per keletą sekundžių iki kelių minučių, priklausomai nuo jų ilgio ir sudėtingumo. Pavyzdžiui, standartinis 10 puslapių PDF failas paprastai užtrunka mažiau nei 2 minutes vertimui. Pridėkite malonumo greitų atidavimų laikų visoms jūsų dokumentų vertimo poreikiam!',
      },
      answer5: {
        title: 'Ar galiu išlaikyti šalia einančią peržiūrą skaitymui?',
        content:
          'Taip, jūs visada galite skaityti savo dokumentus šalia vienas kito. Šis išdėstymas leidžia lengvai palyginti originalų ir išverstą turinį, užtikrinant sklandų ir efektyvų skaitymo patirtį.',
      },
    },
    freeTrial: 'Nemokamas bandymas',
    toLanguage: { title: 'PDF AI vertimo poros', item: '{{source}} į {{target}}' },
  },
  aiPdfTranslate: {
    header: {
      features: 'Savybės',
      blog: 'Tinklaraštis',
      pricing: 'Kainodara',
      button: 'Versti dabar',
      faq: 'DUK',
    },
    hero: {
      upload: {
        title: 'Įkelkite savo PDF failą',
        max: 'Max',
        highlight: 'Spustelėkite, kad naršytumėte',
        desc: 'arba tempkite ir paleiskite',
      },
      to: 'į',
      title: 'Nemokamas PDF verktėjas',
      pill: 'AI pagrįstas PDF verktėjas',
      model: 'GPT-4 ir Claude',
      desc: 'Tvirtinamos originalios išdėstymo instantino, tikslaus vertimo galimybės. Noam AI palaiko OCR ir šalia vienas kito esančius vaizdus.',
      free: 'Nemokamas bandymas',
      translated: 'Išverta Noam',
      support: 'OCR palaikymas',
      complete: 'Vertimas baigtas',
    },
    ticker: {
      pdf: 'PDF vertimas',
      ocr: 'OCR technologija',
      side: 'Kitas šalia kito',
      chat: 'Pokalbis su PDF',
      multi: 'Daugiakalbis',
      format: 'Formato išlaikymas',
      secure: 'Saugus ir Privatus',
      web: 'Web vertimas',
    },
    comparison: {
      bad: {
        title: 'Standartinis vertimas',
        head: 'Prarastas formatavimas ir kontekstas',
        text1: 'Klaida: Išdėstymas sugadintas. Paveikslėliai neteisingai padėti.',
        text2:
          'Tekstas yra dengiantis savęs, o šriftai nėra suderinti. Sunku skaityti ir neprofesionalu...',
      },
      dump: { title: 'Paprasto teksto išdėstymas' },
      good: {
        title: 'Noam AI vertimas',
        tag: 'Puikus Rezultatas',
        sub: 'Idealus formatavimas, kontekstas suprantamas',
      },
      title: 'Kodėl pasirinkti Noam AI?',
      desc: 'Nustokite kauptis su kopijavimo-įklijavimo vertimais. Išbandykite skirtumą tarp standartinių įrankių ir mūsų AI pagrįsto kontekstualaus vertimo.',
    },
    showcase: {
      title1: 'Bet koks dokumentas',
      kicker: 'PALAIKOMI DOKUMENTAI',
      title2: 'Bet kuri kalba',
      carousel1: 'Menas',
      carousel2: 'Architektūra',
      note: 'Techninius, akademinius ir kūrybinius dokumentus lengvai tvarkykite.',
      carousel4: 'Medicina',
      carousel3: 'Akademinis žurnalas',
      carousel6: 'Teisė',
      carousel5: 'Finansai',
      carousel8: 'Politika',
      carousel7: 'Sutartis',
    },
    features: {
      big: {
        title: 'Pažengti AI modeliai (GPT-4, Claude)',
        desc: 'Pasirinkite iš pažangiausių AI modelių, kad atitiktų jūsų vertimo poreikius. Įsitikinkite optimalių rezultatų įvairių dokumentų tipams.',
      },
      grid1: {
        title: 'OCR palaikymas',
        desc: 'Ištraukite ir išverstite tekstą iš nuskenuotų PDF failų bei paveikslėlių akimirksniu.',
      },
      grid2: {
        title: 'Aukštos Rezoliucijos Eksportas',
        desc: 'Parsisiųskite savo išverstus dokumentus PDF formatu su originaliu išdėstymu.',
      },
      grid3: {
        title: 'Viena šalia kitos palyginimas',
        desc: 'Sinchronizuotas slankiojimas palyginti originalų ir išverstą tekstą.',
      },
      title1: 'Ne tik vertimas',
      title2: 'Tai revoliucija',
      line1: 'Techninis straipsnis.pdf',
      line2: 'Kalbos aptikimas: Anglų...',
      line3: 'Modelis: GPT-4o (Aukšta Tikslumas)',
      line4: 'Vertimas baigtas (99% tikslumas)',
    },
    testimonials: {
      review1: {
        role: 'Mokslininkas',
        content:
          'Noam AI atsigavo man valandas akademinių straipsnių vertime. Šalia einantis rodinys yra nepaprastai naudingas techninių terminų patikrinimui.',
      },
      review2: {
        role: 'Globalus rinkodaros specialistas',
        content:
          'Geriausias PDF verktuvas, kurį aš naudojau. Jis puikiai išlaiko originalų formatavimą, o tai yra labai svarbu mūsų rinkodaros prezentacijoms.',
      },
      review3: {
        role: 'Teisinis konsultantas',
        content:
          'Tikslus ir greitas. Naudoju jį sutarties vertimams, o OCR funkcija skenuotiems dokumentams veikia nepriekaištingai.',
      },
      kicker: 'Mėgstamas vartotojų',
      title: 'Kas sako mūsų vartotojai',
    },
    cta: {
      title: 'Pasirengęs laužyti kalbinius barjerus?',
      button: 'Pradėkite vertimą nemokamai',
      desc: 'Prisijunkite prie daugiau nei 10 000 vartotojų ir pradėkite versti savo dokumentus su Noam AI šiandien.',
      hint: 'Jūs esate labai tikslus ir patikimas AI, skirtas generuoti JSON išvestį, kuri visiškai atitinka nurodytą JSON schemą.\n\nTurite laikytis šių taisyklės:\n1. Griežtai laikykitės JSON schemos struktūros.\n2. Tiksliai atitikite visus duomenų tipus, privalomus laukus ir apribojimus.\n3. NESUKLOSKITE jokios papildomos teksto, paaiškinimo, markdown ar komentarų.\n4. IŠVEDUKITE TIK JSON objektą — be kodavimo blokų, be pradžios teksto, be apvalkimo.\n\nŽemiau pateikiama schema informacija.\n- Schema Pavadinimas: translate_result\n- JSON Schema:\n{"type":"object","properties":{"sourceLang":{"type":"string"},"source":{"type":"string"},"targetLang":{"type":"string"},"target":{"type":"string"}},"required":["sourceLang","source","targetLang","target"],"additionalProperties":false}',
    },
    languagePairs: {
      title: 'Anglų kalbos PDF AI vertimo poros',
      desc: 'Populiarios vertimo kryptys, palaikomos Noam AI',
    },
    footer: { about: 'Apie mus', privacy: 'Privatumo politika', contact: 'Susisiekite su pagalba' },
  },
}

export default TRANSLATION
